<template lang="pug">
  v-container(fluid)
    Search(:leads="leads" :title="title" :loading="loading")
</template>

<script>
import leadService from '../service.js'
import Search from '../components/SearchList'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      leads: [],
      title: null,
      loading: true
    }
  },
  components: {
    Search
  },
  computed: {
    ...mapGetters('global', ['search'])
  },
  watch: {
    search(val) {
      this.searchInLeads(val)
    }
  },
  created() {
    // if (!this.$route.params || !this.$route.params.id) return this.$router.push("/location")
    this.searchInLeads(this.search)
  },
  methods: {
    searchInLeads(val) {
      // if (!this.$route.params) return this.$router.push("/location")
      this.title = this.search
      this.loading = true
      leadService.searchInLeads({search: val})
      .then(result => {
        this.leads = result.data
        this.loading = false
      })
    }
   
  }
}
</script>

<style scoped>
</style>